module.exports = __webpack_public_path__ + "static/media/watchlist.a33f88d0.png";